 export const TopBrands_Images = [
   {
     src: "https://images-static.nykaa.com/uploads/5d5bcfd4-216a-4142-a6d3-1d065ba6de61.png?tr=w-800,cm-pad_resize",
     pink: "Up To 40% Off",
     grey: "Ace your base with Lakme !",
   },
   {
     src: "https://images-static.nykaa.com/uploads/de60c862-c495-4488-af69-d3abdcd71652.jpg?tr=w-800,cm-pad_resize",
     pink: "Up To 50% Off + Free Serum",
     grey: "Worth 799 on 799",
   },
   {
     src: "https://images-static.nykaa.com/uploads/c076f59b-c59c-4c72-8414-d4e6ec22c45d.jpg?tr=w-800,cm-pad_resize",
     pink: "Up To 20% Off",
     grey: "On Full-size Products",
   },
   {
     src: "https://images-static.nykaa.com/uploads/eff91756-a301-442b-a566-2b09bdb25335.jpg?tr=w-800,cm-pad_resize",
     pink: "Offers you can't resist",
     grey: "On your favourite luxe brands!",
   },
   {
     src: "https://images-static.nykaa.com/uploads/8981091d-5068-4c04-9cc8-bf83ea019d91.jpg?tr=w-800,cm-pad_resize",
     pink: "On ₹60000: 2 Gifts",
     grey: "Flawless Complexion Icons!",
   },
   {
     src: "https://images-static.nykaa.com/uploads/420ea236-8596-4ac7-8ca3-320efc41c30a.jpg?tr=w-800,cm-pad_resize",
     pink: "Up To 40% Off",
     grey: "100+ Lipsticks to Choose Form!",
   },
   {
     src: "https://images-static.nykaa.com/uploads/d6a85ced-6118-4822-b905-2c708958a3fa.jpg?tr=w-800,cm-pad_resize",
     pink: "Up To 30% Off",
     grey: "Skin specialist face serums",
   },
   {
     src: "https://images-static.nykaa.com/uploads/ba839e0b-b12b-4d93-84c4-b7bc143d649e.jpg?tr=w-800,cm-pad_resize",
     pink: "Up To 20% Off",
     grey: "Complimentary Gifts On Bestsellers",
   },
   {
     src: "https://images-static.nykaa.com/uploads/4701d9fd-3fc5-4cb3-8cdd-eb7939ebca33.jpg?tr=w-800,cm-pad_resize",
     pink: "Complete Your Party Look In Minutes",
     grey: "With Huda Beauty;s Lovefest Collection",
   },
 ];
